import React, { Component } from 'react';

import { Container, Row, Col, Card } from 'reactstrap';
import { Form } from 'react-bootstrap';
import classes from './DeviceMonitorEditorBased.module.css';
import GoogleMapsComponent from '../../Dashboard/Maps/GoogleMapsComponent';
import { withTranslation } from 'react-i18next';
import CommandPanel from './CommandPanel';
import EditorBasedKeypad from '../Machines/EditorBasedKeypad/EditorBasedKeypad';
import editorMachines from '../../../services/api/editor/editorMachines';
import UserUtil from '../../../services/util/userUtil';

class DeviceMonitorEditorBased extends Component {
	state = {
		remoteControl: false,
		selectedSlaveIndex: 0,
		editorMachineDefinitions: [],
		activeSlaveIndex: 0
	};

	constructor(props) {
		super(props);
	}

	render() {
		const { t } = this.props;
		const { machine, products } = this.props;

		if (!machine || !machine.name || !machine.machine) return <></>;
		const vmID = machine.vmID;
		const machineKeyboards = [];
		const slaveKeyboards = [];
		const slaveTabs = [];

		let location =
			(machine.country ? machine.country : '') +
			' ' +
			(machine.city ? machine.city : '') +
			' ' +
			(machine.address ? machine.address : '') +
			' ' +
			(machine.zipcode ? machine.zipcode : '');

		const editorMachineParamValue =
			machine && machine.params.MasterMachine?.length > 0
				? machine.params.MasterMachine[0].parameterValue
				: undefined;

		if (!editorMachineParamValue) return (<>Please apply a layout.</>);

		const paramObject = JSON.parse(editorMachineParamValue);
		// Set up master keypad
		const editorMachineId = paramObject.editorMachineId;		
		machineKeyboards.push(
			<div key="masterkeyboard">
				<EditorBasedKeypad
					prefix=""
					editorMachineId={editorMachineId}									
					vmID={vmID}
					products={products}
					style={{
						width: '100%'
					}}
					remoteControlServiceEnabled={
						machine.remoteControlServiceEnabled === 'Y'
					}
					onRemoteControlSwitched={remoteControl => {
						this.setState({ remoteControl });
					}}
					remoteControlEnabled={this.state.remoteControl}
				></EditorBasedKeypad>
			</div>
		);

		// Set up slave keypads
		if (machine.slaves) {
			machine.slaves.forEach((slave, index) => {
				slaveTabs.push(
					<div
						key={`slaveTab-${slave.prefix}`}
						type="button"
						className="btn btn-secondary"
						style={{
							color: this.state.activeSlaveIndex === index ? 'white' : '',
							backgroundColor: this.state.activeSlaveIndex === index ? 'rgb(68, 77, 88)' : '',
							borderColor: this.state.activeSlaveIndex === index ? 'rgb(68, 77, 88)' : ''
						}}
						onClick={() => {							
							this.setState({ activeSlaveIndex: index });
						}}
					>
						{slave.prefix} -{' '}
						{
							this.state.editorMachineDefinitions.find(
								item => item.MachineID == slave.editorMachineId
							)?.MachineName
						}
					</div>
				);
			});
			
			machine.slaves.forEach((slave, index) => {
				slaveKeyboards.push(
					<div
						key={slave.prefix}
						style={{
							display: this.state.activeSlaveIndex === index ? 'block' : 'none'
						}}
					>
						<EditorBasedKeypad
							prefix={slave.prefix}
							editorMachineId={slave.editorMachineId}							
							vmID={vmID}
							products={products}
							style={{
								width: '100%'
							}}
							remoteControlEnabled={this.state.remoteControl}
						></EditorBasedKeypad>
					</div>
				);
			});
		}

		return (
			<Container style={{ maxWidth: '100%' }}>
				<Col>
					{machine.slaves &&
					machine.slaves.length > 0 &&
					machine.slaves[this.state.selectedSlaveIndex].prefix &&
					machine.slaves[this.state.selectedSlaveIndex].prefix.length > 0 ? (
						<>
							<Row className={classes.HeaderRowSlave}>
								<Col xl="7" lg="12" md="12" xs="12">
									<Row>
										<Col>
											<Col>
												<Col>
													<Form.Label>{t('device.details.name')}</Form.Label>
												</Col>
												<Col className={classes.LabelCol}>
													<Form.Label>{machine.customName}</Form.Label>
												</Col>
											</Col>
											<Col>
												<Col>
													<Form.Label>
														{t('device.details.geoLocation')}
													</Form.Label>
												</Col>
												<Col className={classes.LabelCol}>
													<Form.Label>
														{location && location.length > 3
															? location
															: t('promotionManager.promotionTable.noData')}
													</Form.Label>
												</Col>
											</Col>
										</Col>
										<Col>
											{machine && machine.lat && machine.lng ? (
												<Card className={classes.LocationCard}>
													<div className="chart-wrapper">
														<GoogleMapsComponent
															machines={[machine]}
															monitor="true"
														/>
													</div>
												</Card>
											) : null}
										</Col>
									</Row>
								</Col>

								<Col xl="5" lg="12" md="12" xs="12"></Col>
							</Row>
							<Row className={classes.HeaderRow}>
								<Col
									xl="7"
									lg="12"
									md="12"
									xs="12"
									className={classes.SlaveCol}
								>
									{t('device.details.datasheet.master')}
								</Col>

								<Col
									xl="5"
									lg="12"
									md="12"
									xs="12"
									className={classes.SlaveCol}
								>
									{t('device.details.datasheet.slave')}
								</Col>
							</Row>
							<Row className={classes.HeaderRow}>
								<Col xl="7" lg="12" md="12" xs="12">
									<CommandPanel machine={machine} />
								</Col>
							</Row>
						</>
					) : (
						<Row style={{ paddingRight: '40px' }}>
							<Col xl="7" lg="12" md="12" xs="12" className={classes.HeaderCol}>
								<Row>
									<Col>
										<Col>
											<Col>
												<Form.Label>{t('device.details.name')}</Form.Label>
											</Col>
											<Col className={classes.LabelCol}>
												<Form.Label>{machine.customName}</Form.Label>
											</Col>
										</Col>
										<Col>
											<Col>
												<Form.Label>
													{t('device.details.geoLocation')}
												</Form.Label>
											</Col>
											<Col className={classes.LabelCol}>
												<Form.Label>
													{location && location.length > 3
														? location
														: t('promotionManager.promotionTable.noData')}
												</Form.Label>
											</Col>
										</Col>
									</Col>
									<Col>
										{machine && machine.lat && machine.lng ? (
											<Card className={classes.LocationCard}>
												<div className="chart-wrapper">
													<GoogleMapsComponent machines={[machine]} monitor />
												</div>
											</Card>
										) : null}
									</Col>
								</Row>

								<CommandPanel machine={machine} monitor="true" />
							</Col>
						</Row>
					)}
				</Col>

				<Row style={{ marginTop: '10px' }}>
					<Col>
						<div style={{ width: 'fit-content' }}>{machineKeyboards}</div>
					</Col>
					<Col>
						<div style={{ width: 'fit-content' }}>
							<div
								className="btn-toolbar"
								role="toolbar"
								aria-label="Toolbar with button groups"
							>
								<div
									className="btn-group mr-2"
									role="group"
									aria-label="First group"
								>
									{slaveTabs}
								</div>
							</div>
							{slaveKeyboards}
						</div>
					</Col>
				</Row>
			</Container>
		);
	}
}

export default withTranslation()(DeviceMonitorEditorBased);
